export enum DocumentTypeEnum {
    None = 1,
    Word = 2,
    Excel = 3,
    PDF = 4,
    Text = 5,
    HTML = 6,
    TIFF = 7,
    Zip = 8,
    PNG = 9,
    JPG = 10,
    DOCX = 11,
    BMP = 12,
    MSG = 13,
    HEIC = 14,
}
